/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.addLicense("ch-custom-attribution");
am4core.useTheme(am4themes_animated);
class TpeListDetails extends Component {

    chartDiv = React.createRef();
    chart = null;
    chartCreated = false;

    componentDidMount() {
        this.charCreate("Chart", "",
            this.props.gsc_score1,
            this.props.gsc_score2,
            this.props.gsc_score3,
            this.props.gsc_maxscore1,
            this.props.gsc_maxscore2,
            this.props.gsc_maxscore3,
            this.props.questionSelectionTypes);
    }

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }


    charCreate(id, text, score1, score2, score3, max1, max2, max3, _questionSelectionTypes) {

        let chart = am4core.create(this.chartDiv.current, am4charts.XYChart3D);

        am4core.useTheme(am4themes_animated);
        am4core.options.autoDispose = true;
        var maxtotal = max1 + max2 + max3;

        var scor1islem = Number((score1 / max1) * 100).toFixed(2);
        var scor2islem = Number((score2 / max2) * 100).toFixed(2);
        var scor3islem = Number((score3 / max3) * 100).toFixed(2);

        // Add data
        chart.data = [{
            "country": _questionSelectionTypes.filter((z) => z.order === "1")[0].name,
            "sinav": scor1islem,
            "genel": maxtotal
        }, {
            "country": _questionSelectionTypes.filter((z) => z.order === "2")[0].name,
            "sinav": scor2islem,
            "genel": maxtotal
        }, {
            "country": _questionSelectionTypes.filter((z) => z.order === "3")[0].name,
            "sinav": scor3islem,
            "genel": maxtotal
        }];

        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "country";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.fontSize = 11;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        // valueAxis.title.text = text;
        valueAxis.renderer.labels.template.adapter.add("text", function (text) {
            return text + "%";
        });
        valueAxis.fontSize = 13;

        valueAxis.min = 0;
        valueAxis.max = 100;

        var series = chart.series.push(new am4charts.ColumnSeries3D());
        series.dataFields.valueY = "sinav";
        series.dataFields.categoryX = "country";
        series.name = "sinav";
        series.clustered = false;
        series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
        series.columns.template.fillOpacity = 0.9;
        series.columns.template.fill = am4core.color("#2d96cd");

        var series2 = chart.series.push(new am4charts.ColumnSeries3D());
        series2.dataFields.valueY = "genel";
        series2.dataFields.categoryX = "country";
        series2.name = "Total";
        series2.clustered = false;
        series2.columns.template.tooltipText = "Total : [bold]{valueY}[/]";
        series2.columns.template.fill = am4core.color("#4cc790");

        this.chart = chart;

    }



    render() {
        return <div>

            <div
                ref={this.chartDiv}
                id="Tpe_chart"
                className="mt-4"
                style={{ width: "100%", height: "550px" }}
            ></div>

        </div>;
    }

}

export default TpeListDetails;